export const VERIFY_EMAIL_OTP_PAGE_ID = 'emailOtpScreen';
